module.exports = __webpack_public_path__ + "img/108.3e0c1847.jpg";